export const FEATURES_COMPATIBILITY_RESOURCE_NAME = 'compatibility'
export const FEATURES_COMPATIBILITY_PREFIX = 'MONITORING'

export type Compatibility = {
  compatible: boolean,
  reason?: string
}

export type FeaturesCompatibility = {
  apiMetrics: Compatibility
}